/**
 * Values Block.
 * 
 */

/**
 * Desktop: Set height of values container so that total height of left content matches right.
 * Mobile: Nothing.
 * NB. The Values Block uses Mission's markup (part/partial).
 */

let 
	$window = $(window),
	prevWindowW = window.innerWidth,
	currWindowW = prevWindowW,
	breakpoint = 1024,
	$right_photo = $('.mission-block__image img.desktop'),
	$left_heading = $('.mission-block__heading'),
	$left_blurb = $('.mission-block__blurb'),
	$left_values = $('.mission-block__benefits');

function setValuesHeight() {
	// console.log("VALUES: setValuesHeight()");

	/*
		1. Get height of right side/right side image. height_right
		2. Get height of left side header (heading + blurb). height_left_header
		3. Set height of left side values to height_right - height_left_header.
	*/

	let
		right_h = $right_photo.outerHeight(),
		left_header_h = $left_heading.outerHeight() + parseInt($left_heading.css('margin-bottom'), 10) + $left_blurb.outerHeight(),
		left_margin_h = parseInt($left_values.css('margin-top'), 10);

	var left_values_h = right_h - left_header_h - left_margin_h;

	$left_values.css('height', left_values_h);
}

function initResizeWatcher() {
	// console.log('VALUES: initResizeWatcher()');

	$window.on('resize', function() {
		// console.log('currWindowW: '+currWindowW);

		currWindowW = window.innerWidth;

		// Viewport crosses from mobile to desktop.
		if ((currWindowW >= breakpoint) && (prevWindowW < breakpoint)) {
		}

		// Viewport crosses from desktop to mobile.
		if ((currWindowW < breakpoint) && (prevWindowW >= breakpoint)) {
			$left_values.css('height', '');
		}

		// Viewport is mobile.
		if (currWindowW < breakpoint) {
			$left_values.css('display','flex');
		}

		// Viewport is desktop.
		if (currWindowW >= breakpoint) {
			// Set values height.
			setValuesHeight();
			$left_values.css('display','block');
		}

		prevWindowW = window.innerWidth;
	});
}

exports.init = function () {
	// console.log('VALUES: exports.init');
    // Run init methods...

	$left_values.css('display','none');
	// $(setValuesHeight);	// After document load.

	$(function() {	// After document load.
		if (window.innerWidth >= breakpoint) {
		// if ($window.width() > breakpoint) {
			setValuesHeight();
		}
		$left_values.css('display','block');
		initResizeWatcher();
	});

	// $right_photo.on('load', function() {	// After right image loads.
	// 	if (window.innerWidth >= breakpoint) {
	// 	// if ($window.width() > breakpoint) {
	// 		setValuesHeight();
	// 	}
	// 	$left_values.css('display','block');
	// 	initResizeWatcher();
	// });
};